import React from 'react';
import styles from 'Custom/Card/basicCard.module.scss';

const CARD_TYPES = {
  enrollment: styles.enrollment,
  default: styles.enrollment,
};

const Card = ({
  className = '',
  title = '',
  type = 'default',
  children,
  ...props
}) => {
  const typeClassName = CARD_TYPES[type] || CARD_TYPES.default;

  return (
    <div className={`${styles.card} ${typeClassName} ${className}`} {...props}>
      {title && <span className={styles.title}>{title}</span>}
      <div className={styles.cardContent}>{children}</div>
    </div>
  );
};

export default Card;
